/** List of known extension keys on the plan */ export var PlanExtensionKeys = /*#__PURE__*/ function(PlanExtensionKeys) {
    /** Service understood legacy data from basic plans */ PlanExtensionKeys["legacyData"] = "LegacyData";
    /** The copilot extension data for the plan */ PlanExtensionKeys["copilot"] = "copilot";
    return PlanExtensionKeys;
}({});
/**
 * List of known extension keys for the plan view
 */ export var PlanViewExtensionKeys = /*#__PURE__*/ function(PlanViewExtensionKeys) {
    /** Service understood legacy data from basic plans */ PlanViewExtensionKeys["legacyData"] = "LegacyData";
    /** The visual extension data for the plan */ PlanViewExtensionKeys["visuals"] = "visuals";
    return PlanViewExtensionKeys;
}({});
/**
 * List of known extension keys for the plan personal view
 */ export var PlanPersonalViewExtensionKeys = /*#__PURE__*/ function(PlanPersonalViewExtensionKeys) {
    return PlanPersonalViewExtensionKeys;
}({});
